import React from 'react';
/**
 * VGP Universal Kingdom theme background.
 * "Kingdom of Joy" - royal purple & gold palette.
 */
const ElegantPageBg = () => (
  <div className="elegant-page-bg">
    <div className="elegant-accent-wave" />
    <div className="elegant-blur-orb" />
    <div className="elegant-blur-orb-2" />
  </div>
);

export default ElegantPageBg;
